import { StyledButton } from '@zillow/constellation';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

const INVALID_HTML_ATTRIBUTES = new Set(['buttonType', 'fluid']);

export default styled(StyledButton)
  .attrs({
    as: Link,
  })
  .withConfig({
    shouldForwardProp(prop, defaultValidatorFn) {
      return !INVALID_HTML_ATTRIBUTES.has(prop) && defaultValidatorFn(prop);
    },
  })``;
